import { JobApplication } from '../models/job-application.model';
import { BaseService } from '../../../../../core/services/base.service';
import { getApiBaseUrl } from '../../../../../core/config/runtimeConfig';
import { useAuthStore } from '../../../../../core/store/auth.store';
import { UtilService } from '../../../../../core/services/util.service';

export class JobApplicationStagesService {


  static async AddStage(
    id: string,
    statusId: string,
    content: string,
    notificationId: string | null,
    useEditedMessage = false
  ): Promise<JobApplication> {
    return await BaseService.Post(`/job-applications/${id}/statuses`, {
      statusId,
      content,
      ...(notificationId ? { notificationId } : {}),
      useEditedMessage,
    });
  }

  private static async RequestWithStringBody(method: string, url: string, body: string): Promise<any> {
    const utils = UtilService.GetInstance();
    utils.beginBlockingLoad();
    
    try {
      const auth = useAuthStore.getState().getAuth();
      
      const response = await fetch(url, {
        method,
        headers: {
          'accept': '*/*',
          'Content-Type': 'application/json',
          'Authorization': `bearer ${auth?.accessToken.accessToken}`
        },
        body: body
      });

      if (response.status === 401) {
        UtilService.Alert('Important!', 'info', 'Session Expired. Please Login');
        window.location.href = '/#/login';
        return;
      }

      if (response.status === 204) {
        return;
      }

      let data = await response.json();
      
      if (response.ok) {
        return data;
      }

      if (response.status === 404) {
        throw new Error("NOT FOUND");
      }

      const message = data.message || `HTTP error! Status: ${response.status}`;
      throw new Error(message);
    } catch (error: any) {
      if (error?.message.includes("VALIDATION: ")) {
        throw error;
      }

      let message: string = "Internal Server Error";
      if (error?.message.includes("SHOW: ")) {
        message = error.message.replace("SHOW: ", "");
      }

      UtilService.Alert('Important!', 'info', message);
    } finally {
      utils.endBlockingLoad();
    }
  }

  static async AddStageNote(
    statusId: string,
    content: string
  ): Promise<any> {
    const url = `${getApiBaseUrl()}/statuses/${statusId}/notes`;
    return await this.RequestWithStringBody('POST', url, content);
  }

  static async DeleteStageNote(statusId: string, noteId: string): Promise<any> {
    return await BaseService.Delete(`/statuses/${statusId}/notes/${noteId}`);
  }

  static async UpdateStageNote(
    statusId: string,
    noteId: string,
    content: string
  ): Promise<any> {
    const url = `${getApiBaseUrl()}/statuses/${statusId}/notes/${noteId}`;
    return await this.RequestWithStringBody('PATCH', url, content);
  }
}
